import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import MapImg from "./img/MapImg.png";
import Crow_img_1 from "./img/Crow/2.png";
function Map (){
    return (
      <Category_wrapper>
          <Item_wrapper>
            <Content_span>
              Map
            </Content_span>
            <Content_span>
              Address
            </Content_span>
            <Content_span2>
            
Department of Urology, Seoul National University Hospital, Seoul National University College of Medicine
101 Daehak-ro, Jongno-gu, Seoul 03080, Republic of Korea	
<br/>
Biomedical Research Institute 11st floor 

            </Content_span2>
            <Content_span2>
            </Content_span2>
          <Category_div>
          <Iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1580.9698859652356!2d126.99648827602618!3d37.58003589492414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca37dc8a20bf5%3A0x99f960ed06630bd0!2z7ISc7Jq464yA7ZWZ6rWQ67OR7JuQIOydmOyDneuqheyXsOq1rOybkA!5e0!3m2!1sko!2skr!4v1619357078161!5m2!1sko!2skr" width="800" height="600" allowfullscreen="" loading="lazy"></Iframe>
          </Category_div>
          <Category_div>
            <Img src={MapImg}/>
          </Category_div>
        </Item_wrapper>
        <Crow_img src={Crow_img_1}/>
      </Category_wrapper>
    )
  }
  const Crow_img = styled.img`
  width : 300px; 
  height : 177.867px;
  position : absolute;
  bottom:-70px;
  right : 0px;
  `
  const Img = styled.img`
  width : 800px; 
  height : 437.818px;
  `
  const Item_wrapper = styled.div`
  width : 880px;
  margin : 70px auto;
  `

  const Category_wrapper = styled.div`
    width : 1200px;
    margin : 0px auto;
    padding : 50px 0;
    font-family: "En";        
    position : relative;
    `
  const Category_div = styled.div`
    display : block;
    text-align : center;
    vertical-align : top;
    background: white;
    margin : 0 auto;
    `
    const Iframe = styled.iframe`
      margin : 30px 0; 
    `
  const Content_span = styled.span`
  font-family: "Title";        
    display : block;
    font-size : 35px; 
    font-weight : bold; 
    width : 750px;
    box-sizing : border-box  ;
    &:nth-child(2){
      font-family: "Table_title";        
      margin : 20px 0 ;
      margin-top : 50px;
      font-size: 27px; 

    }
  `
  const Content_span2 = styled.span`
  display : inline-block;
  font-size : 20px; 
  margin: 0; 
  height : 30px;
  line-height: 35px;
  font-family: "Content";        
  `
  
  export default Map;